<template>
  <div>
    <div class="columns">
      <div class="column">
        <div>
          <p><b>Image</b></p>
          <div class="is-flex is-align-items-center">
            <input class="p-0 " style="border-radius: 0;" type="file" accept="image/*" @change="getImageFile" />
            <div class="horizontal_space"></div>
            <p class="bold" v-if="selected_image_file">{{ selected_image_file.name }}</p>
          </div>
        </div>
      </div>
      <div class="column column-border-right mx-5">
        <img v-if="imageUrl" alt="" class="image" :src="imageUrl" />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div>
          <div class="vertical_space"></div>
          <p><b>Title</b></p>
          <input class="outlined full_width" placeholder="כותרת" v-model="title" />
        </div>
      </div>
      <div class="column column-border-right mx-5 mt-4">
        <div v-if="title" class="has-text-centered">
          <h1 class="is-size-1 has-text-weight-bold mt-3">{{ title }}</h1>
          <p class="my-4">
            ע"י <b>{{ env }}</b>
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div>
          <div class="vertical_space"></div>
          <p><b>Content</b></p>
          <quill
            v-if="payload.is_create || blog != undefined"
            v-model="content"
            dir="rtl"
            style="text-align: left;"
            ref="quill"
            output="html"
            :config="quill_config"
          >
          </quill>
        </div>
      </div>
      <div class="column column-border-right mx-5 mt-4">
        <div class="is-flex is-justify-content-center">
          <div v-if="content" class="blog-content ql-editor" v-html="content"></div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div>
          <div class="vertical_space"></div>
          <p><b>Priority</b></p>
          <input class="outlined" placeholder="עדיפות" v-model="priority" />
        </div>
        <div>
          <div class="vertical_space"></div>
          <p><b>Tags</b></p>
          <input class="outlined" placeholder="..." v-model="tags" />
        </div>
        <div>
          <div class="vertical_space"></div>
          <p><b>Status</b></p>
          <select dir="rtl" v-model="status">
            <option>active</option>
            <option>blocked</option>
          </select>
        </div>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a @click="submit()" :class="{ 'is-loading': is_loading }" class="button is-info">Submit</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Quill from 'vue-quill/src/Quill.vue'
export default {
  name: 'admin-blog-form',
  props: ['payload'],
  data () {
    return {
      blog: undefined,
      priority: '',
      tags: '',
      status: 'active',
      title: '',
      content: '',
      is_loading: false,
      selected_image_file: undefined,
      quill_config: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ size: ['small', false, 'large', 'huge'] }],
            ['link', 'image', 'video'],
            [{ direction: 'rtl' }],
            [{ color: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean']
          ]
        }
      }
    }
  },
  computed: {
    env () {
      return this.$settings.get({ path: 'operation_name' })
    },
    imageUrl () {
      return this.selected_image_file ? URL.createObjectURL(this.selected_image_file) : undefined
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setDefaultAlignRight()
        return
      }
      this.$network_utils.getBlog({ id: this.payload.data.id }).then(response => {
        this.blog = response
        this.tags = response.tags
        this.title = response.title
        this.content = response.content
      })
    },
    setDefaultAlignRight () {
      this.$refs.quill.$el.querySelector('p').classList.add('ql-align-right')
    },
    getImageFile (event) {
      this.selected_image_file = event.target.files[0]
    },
    submit () {
      if (this.selected_image_file == undefined) {
        this.$utils.emit('show_toast', { text: 'אנא בחר/י תמונה' })
        return
      }
      this.is_loading = true
      this.postBlog()
    },
    postBlog () {
      let form_data = new FormData()
      form_data.append('title', this.title)
      form_data.append('content', this.content)
      form_data.append('priority', this.priority * 1)
      form_data.append('tags', this.tags)
      form_data.append('status', this.status)
      if (this.payload.is_create == false) {
        form_data.append('id', this.blog.id)
      }
      if (this.selected_image_file != undefined) {
        form_data.append('image', this.selected_image_file)
      }
      if (this.payload.is_create) {
        this.$network_utils
          .postBlog(form_data)
          .then(() => {
            this.onRequestSuccess()
          })
          .catch(() => {
            this.onRequestFailed()
          })
        return
      }
      this.$network_utils
        .updateBlog(this.blog.id, form_data)
        .then(() => {
          this.onRequestSuccess()
        })
        .catch(() => {
          this.onRequestFailed()
        })
    },
    onRequestSuccess () {
      this.is_loading = false
      this.$utils.emit('show_toast', { text: 'success' })
      this.remove(this.payload)
    },
    onRequestFailed () {
      this.$utils.emit('show_toast', { text: 'ארעה שגיאה. כנראה שהתמונה גדולה מדיי ' })
      this.is_loading = false
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Quill
  }
}
</script>
<style>
.ql-editor {
  min-height: 420px;
}
.ql-editor a {
  text-decoration: underline;
}
.image {
  border-radius: 13px;
  object-fit: cover;
  width: 100%;
  max-height: 550px;
}
.blog-content {
  white-space: pre-line;
  margin-top: 30px;
  font-size: 0.8em;
  padding: 30px;
}
.column-border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
